export default function (url, section = 1) {
  const sections = url.split("/").filter((section) => !!section);

  return sections[section] || "";
}
